import React, { useState } from "react";
import "../../assets/css/SalesTrend/SalesTrend.css";
import SalesTrendHeader from "../SalesTrendHeader.tsx";
import BrandFilter from "./components/BrandFilter.js";
import BrandTable from "./components/BrandTable.tsx";
import { API_BASE_URL } from "../../config/config";
import BrandAnalysisStatus from "./components/BrandAnalysisStatus.js";
import QuaterlyPerformance from "../SalesTrend/components/QuaterlyPerformance.js";
import { useTokenFromQuery, useFetchUserDetails, getUserIdFromToken ,useResetRefreshTime } from "../../utils/dashboardUtils.js";

function BrandWiseSales() {
 
const [refreshTime, setRefreshTime] = useState(null);
  const [userLoaction, setuserLocation] = useState(null);
  const [headerUsername, setheaderUsername] = useState(null);

  useTokenFromQuery("/app/brandwisesales_dashboard");
  useFetchUserDetails(setuserLocation, setheaderUsername, setRefreshTime, API_BASE_URL , "BrandWiseSalesDashboard");
  useResetRefreshTime(setRefreshTime);
  const user_id = getUserIdFromToken();
    
  return (
    <div className="sales-trend-dashboard">
      <div className="dashboard-container">
        <SalesTrendHeader
          title="Brand Wise Sales (Daily)"
          userName={headerUsername}
          location={userLoaction}
          refreshTime={refreshTime}
        />

        <div className="new-filter-bar-sticky">
          <BrandFilter
            user_id={user_id}
            apiEndpoint="Dashboard/BrandWiseSalesDashboard"
            isNewBrand={false}
          />
        </div>

        <BrandAnalysisStatus theadiing="TOP 3 Brand Growth Wise" />
        <QuaterlyPerformance />
        <BrandTable Fname="BrandTable_Data_Report.csv" />
      </div>
    </div>
  );
}

export default BrandWiseSales;
